var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center text-subtitle-2"},[_vm._v("Signed")]),_c('div',{staticClass:"text-center text-h5"},[_vm._v(_vm._s(_vm.signedTotal))]),_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }